import { Session } from 'next-auth'
import nextApi from '../next-api'

const getSession = () => {
  return nextApi.get<Session>({ url: '/auth/session' })
}

export default getSession
